import React from "react";
import PropTypes from "prop-types";
import { Modal, Spin, Row, Col, Input, Icon, Button, Badge, Tag, Tooltip, Select, Empty } from "antd";
import { get } from "lodash";
import moment from "moment";

import PageError from "App/Component/PageError";
import { Modules, requestV3 } from "App/Utils";

export default class DialogMergeArchitects extends React.PureComponent {
  constructor(props) {
    super(props)

    this._searchTarget = ''
    this._searchSource = ''

    this._nextTarget = null
    this._nextSource = null

    this._pageTarget = 1
    this._pageSource = 1

    this.state = {
      error: null,
      loading: false,
      loadingLoadMoreSource: false,
      loadingLoadMoreTarget: false,
      architects: [],
      similarArchitects: [],
      selectedTarget: null,
      selectedSources: [],
      // searchTarget: "",
      // searchSource: "",
    }
  }

  clearData = () => {
    this.setState({
      similarArchitects: [],
      selectedTarget: null,
      selectedSources: [],
      // searchTarget: "",
      // searchSource: "",
    })
  }

  getArchitects = async (options) => {
    return new Promise((resolve, reject) => {
      requestV3({
        urlKey: 'architects-read',
        onSuccess: (res) => resolve(res),
        onFailed: (error) => reject(error),
        ...options,
        params: { limit: 100, ...get(options, 'params') },
      })
    })
  }

  readInitialData = () => {
    this._searchTarget = ""
    this._searchSource = ""
    this._pageTarget = 1
    this._pageSource = 1
    this._nextTarget = null
    this._nextSource = null

    this.setState({ loading: true, selectedTarget: null, selectedSources: [], architects: [], similarArchitects: [] }, () => {
      this.getArchitects()
        .then((res) => {
          this._nextTarget = res.next
          this._nextSource = res.next
          this.setState({ error: null, architects: res.results || [], similarArchitects: res.results || [] })
        })
        .catch((error) => this.setState({ error: { data: error } }))
        .finally(() => this.setState({ loading: false }))
    })
  }

  readArchitects = () => {
    this._pageTarget = 1
    this._nextTarget = null
    this.setState({ loading: true, selectedTarget: null }, () => {
      this.getArchitects({ params: { search: this._searchTarget } })
        .then((res) => {
          this._nextTarget = res.next
          this.setState({ error: null, architects: res.results || [] })
        })
        .catch((error) => this.setState({ error: { data: error } }))
        .finally(() => this.setState({ loading: false }))
    })
  }

  readSimilarArchitects = () => {
    this._pageSource = 1
    this._nextSource = null
    this.setState({ loading: true, selectedSources: [] }, () => {
      this.getArchitects({ params: { search: this._searchSource } })
        .then((res) => {
          this._nextSource = res.next
          this.setState({ error: null, similarArchitects: res.results || [] })
        })
        .catch((error) => this.setState({ error: { data: error } }))
        .finally(() => this.setState({ loading: false }))
    })
  }

  onSelectTarget = (_, architect) => {
    // const target = this.state.architects.find(architect => architect.pk === pk)
    // this._searchSource = get(target, 'name', '').split(' ').join('|')

    this.setState(prev => ({ selectedTarget: architect }))
  }

  onToggleSource = (_, architect) => {
    this.setState(prev => {
      const exists = prev.selectedSources.some(selectedSource => selectedSource.pk === architect.pk)
      return {
        selectedSources: exists
          ? prev.selectedSources.filter(selectedSource => selectedSource.pk !== architect.pk)
          : [...prev.selectedSources, architect],
      }
    })
  }

  getSelectedSources = () =>
    this.state.selectedSources.filter(selectedSource => selectedSource.pk !== get(this.state.selectedTarget, 'pk'))

  warningMerge = async () => {
    const { architects, similarArchitects, selectedTarget, selectedSources } = this.state
    // const targetObj = architects.find(architect => architect.pk === get(selectedTarget, 'pk'))
    // const sourceObjs = similarArchitects.filter(similarArchitect => selectedSources.findIndex(selectedSource => selectedSource.pk === similarArchitect.pk) !== -1)

    // const targetObj = this.state.selectedTarget
    // const sourceObjs = selectedSources

    // const targetName = get(targetObj, 'name', 'Unknown Target')
    // const sourceNames = sourceObjs.map(s => s.name)
    const filteredSelectedSources = this.getSelectedSources()

    return new Promise((resolve) => {
      Modal.confirm({
        title: (
          <div className="merge-warning-modal-header">
            {/* <Icon type="warning" theme="filled" className="merge-warning-header-icon" /> */}
            <span className="merge-warning-header-title">Confirm Architect Merge</span>
          </div>
        ),
        icon: null,
        width: 580,
        centered: true,
        className: 'merge-warning-modal',
        okText: 'Confirm & Merge',
        okType: 'primary',
        okButtonProps: {
          icon: 'interaction',
          style: { borderRadius: 4, fontWeight: 500 },
        },
        cancelText: 'Cancel',
        cancelButtonProps: {
          style: { borderRadius: 4 },
        },
        content: (
          <div className="merge-warning-body">
            {/* Alert Banner */}
            <div className="merge-warning-alert-banner">
              <Icon type="info-circle" theme="filled" className="merge-warning-alert-icon" />
              <div className="merge-warning-alert-text">
                Please double-check the sources and target to ensure everything is correct.
              </div>
            </div>

            {/* Target vs Sources Summary */}
            <div className="merge-warning-summary-card">
              <div className="merge-warning-summary-row">
                <div className="merge-warning-summary-label source">
                  <Icon type="select" style={{ marginRight: 6 }} />
                  Source Architects
                </div>
                <div className="merge-warning-summary-value">
                  {filteredSelectedSources.map((selectedSource, index) => (
                    <Tag key={index} color="blue" style={{ fontSize: 12, marginBottom: 4, marginTop: 2 }}>
                      {selectedSource.name}
                    </Tag>
                  ))}
                </div>
              </div>

              <div className="merge-warning-summary-divider">
                <Icon type="arrow-down" style={{ color: '#bfbfbf', fontSize: 14 }} />
                <span style={{ fontSize: 11, color: '#8c8c8c', marginLeft: 6 }}>
                  {filteredSelectedSources.length} Sources will merge into Target
                </span>
              </div>

              <div className="merge-warning-summary-row">
                <div className="merge-warning-summary-label target">
                  {/* <Icon type="aim" style={{ marginRight: 6 }} /> */}
                  Target Architect
                </div>
                <div className="merge-warning-summary-value">
                  <Tag color="green" style={{ fontSize: 13, padding: '2px 8px', fontWeight: 600, margin: '2px 0' }}>
                    {this.state.selectedTarget.name}
                  </Tag>
                </div>
              </div>
            </div>

            {/* Merge Process Impact List */}
            <div className="merge-warning-impact-section">
              <div className="merge-warning-impact-title">
                <Icon type="solution" style={{ marginRight: 6, color: '#fa8c16' }} />
                Merge process:
              </div>
              <ul className="merge-warning-impact-list">
                <li className="impact-item-danger">
                  <Icon type="warning" theme="filled" className="impact-icon warning" />
                  <span>This action cannot be undone.</span>
                </li>
                <li>
                  <Icon type="environment" theme="filled" className="impact-icon" />
                  <span>The source architect will be saved as an alias for the target.</span>
                </li>
                <li>
                  <Icon type="branches" className="impact-icon" style={{ fontSize: 14 }} />
                  <span>Source aliases are moved to the target alias.</span>
                </li>
                <li>
                  <Icon type="build" theme="filled" className="impact-icon success" />
                  <span>Building jobs using the source are updated to switch to the target.</span>
                </li>
              </ul>
            </div>
          </div>
        ),
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      })
    })
  }

  mergeArchitects = async () => {
    if (!(await this.warningMerge()))
      return

    this.setState({ loading: true }, () => {
      requestV3({
        method: 'post',
        urlKey: 'architects-merge',
        data: {
          target: get(this.state.selectedTarget, 'pk'),
          sources: this.getSelectedSources().map(selectedSource => selectedSource.pk),
        },
        onSuccess: () => {
          Modules.responseMessage("success", "Architects have been merged")
          this.props.onClose()
        },
        onFailed: (error) => {
          Modules.responseMessage("error", error)
        },
        onBoth: () => this.setState({ loading: false }),
      })
    })
  }

  loadMoreSimilarArchitects = () => {
    if (!this._nextSource || this.state.loadingLoadMoreSource || this.state.loading) return

    this.setState({ loadingLoadMoreSource: true }, () => {
      const nextPage = this._pageSource + 1
      this.getArchitects({ params: { search: this._searchSource, page: nextPage } })
        .then((res) => {
          this._nextSource = res.next
          this._pageSource = nextPage
          this.setState(prev => {
            const existingPks = new Set(prev.similarArchitects.map(a => a.pk))
            const newResults = (res.results || []).filter(a => !existingPks.has(a.pk))
            return {
              similarArchitects: [...prev.similarArchitects, ...newResults]
            }
          })
        })
        .catch((error) => console.error("Error loading more sources:", error))
        .finally(() => this.setState({ loadingLoadMoreSource: false }))
    })
  }

  loadMoreArchitects = () => {
    if (!this._nextTarget || this.state.loadingLoadMoreTarget || this.state.loading) return

    this.setState({ loadingLoadMoreTarget: true }, () => {
      const nextPage = this._pageTarget + 1
      this.getArchitects({ params: { search: this._searchTarget, page: nextPage } })
        .then((res) => {
          this._nextTarget = res.next
          this._pageTarget = nextPage
          this.setState(prev => {
            const existingPks = new Set(prev.architects.map(a => a.pk))
            const newResults = (res.results || []).filter(a => !existingPks.has(a.pk))
            return {
              architects: [...prev.architects, ...newResults]
            }
          })
        })
        .catch((error) => console.error("Error loading more targets:", error))
        .finally(() => this.setState({ loadingLoadMoreTarget: false }))
    })
  }

  onScrollListSource = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target
    if (
      scrollHeight - scrollTop <= clientHeight + 20 &&
      !!this._nextSource &&
      !this.state.loadingLoadMoreSource &&
      !this.state.loading
    ) {
      this.loadMoreSimilarArchitects()
    }
  }

  onScrollListTarget = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target
    if (
      scrollHeight - scrollTop <= clientHeight + 20 &&
      !!this._nextTarget &&
      !this.state.loadingLoadMoreTarget &&
      !this.state.loading
    ) {
      this.loadMoreArchitects()
    }
  }

  getAllowedMerge = () => {
    const selectedSources = this.state.selectedSources.filter(selectedSource => selectedSource.pk !== get(this.state.selectedTarget, 'pk'))
    return this.state.selectedTarget && selectedSources.length > 0 && !this.state.loading
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      this.clearData()
      // this.readArchitects()
      this.readInitialData()
    }
  }

  renderItem = (item, isSelected, onSelect) => {
    return (
      <div
        key={item.pk}
        className={`merge-architect-item ${isSelected ? 'selected' : ''}`}
        onClick={() => onSelect(item.pk, item)}
      >
        <div className="merge-architect-item-check">
          <div className={`merge-architect-checkbox ${isSelected ? 'checked' : ''}`}>
            {isSelected && <Icon type="check" />}
          </div>
        </div>
        <div className="merge-architect-item-content">
          <div className="merge-architect-item-name">
            {item.name} {get(this.state.selectedTarget, 'pk') === item.pk && <Tag color="green">Target</Tag>}
          </div>
          <Row type="flex" align="middle" className="merge-architect-item-date">
            <Icon type="calendar" style={{ marginRight: 4, fontSize: 10 }} />
            {moment(item.created).format('lll')}
          </Row>
        </div>
      </div>
    )
  }

  render() {
    console.log('Rendered', Modules, this)
    const { architects, selectedTarget, selectedSources, searchTarget, searchSource } = this.state

    const filteredArchitectsTarget = architects

    const filteredArchitectsSource = this.state.similarArchitects
    // const filteredArchitectsSource = this.state.similarArchitects.filter(a =>
    //   a.pk !== selectedTarget &&
    //   a.name.toLowerCase().includes(searchSource.toLowerCase())
    // )

    return (
      <Modal
        visible={this.props.visible}
        width={860}
        style={{ top: 20 }}
        title={
          <span>
            <Icon type="pull-request" style={{ marginRight: 8, color: '#1890ff' }} />
            Merge Architects
          </span>
        }
        footer={!this.state.error &&
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 12, color: '#8c8c8c' }}>
              {(selectedTarget && selectedSources.length > 0)
                ? <span><Icon type="info-circle" style={{ marginRight: 4 }} />Sources will be merged into the target</span>
                : <span><Icon type="info-circle" style={{ marginRight: 4 }} />Select a target and at least one source</span>
              }
            </div>
            <div>
              <Button onClick={() => this.props.onClose()}>
                Cancel
              </Button>
              <Button
                type="primary"
                icon="interaction"
                // disabled={!selectedTarget || selectedSources.length === 0 || this.state.loading}
                disabled={!this.getAllowedMerge()}
                style={{ marginLeft: 8 }}
                onClick={this.mergeArchitects}
              >
                Merge
              </Button>
            </div>
          </div>
        }
        onCancel={() => this.props.onClose()}
        bodyStyle={{ padding: 0 }}
      >
        {(this.state.error && !this.state.loading) ? (
          <PageError
            errorResponse={this.state.error}
            onGoBack={() => this.props.onClose()}
            onReload={this.readInitialData}
          />
        ) : (
          <Spin spinning={this.state.loading}>
            <div className="merge-architects-container">
              <Row className="h-100" type="flex">
                {/* Sources */}
                <Col span={12} className="merge-col merge-col-right">
                  <Row type="flex" className="h-100 flex-column flex-nowrap">
                    <Col className="flex-none merge-col-header">
                    {/* <div className="merge-col-header"> */}
                      <div className="merge-col-header-top">
                        <div className="merge-col-title">
                          <Icon type="select" style={{ marginRight: 6 }} />
                          Sources
                          {/* {this.state.similarArchitects.length > 0 && (
                            <span className="ml-1">
                              ({this.state.similarArchitects.length})
                            </span>
                          )} */}
                        </div>
                        {/* <Badge
                          count={selectedSources.length}
                          style={{ backgroundColor: '#1890ff' }}
                          // showZero
                        /> */}
                        {selectedSources.length > 0 && (
                          <span style={{ color: '#999', fontSize: '12px' }}>
                            {selectedSources.length} selected
                          </span>
                        )}
                      </div>
                      <div className="merge-col-subtitle">Select similar architects to merge into the target</div>
                      <Select
                        mode="tags"
                        size="small"
                        value={this._searchSource.split('|').filter(v => v)}
                        // value=""
                        tokenSeparators={['|', ',', ' ']}
                        className="w-100"
                        placeholder="Search similar architects"
                        style={{ marginTop: 8 }}
                        onChange={(val) => {
                          this._searchSource = val.join('|')
                          this.readSimilarArchitects()
                        }}
                      />
                    {/* </div> */}
                    </Col>
                    <Col className="merge-col-list" onScroll={this.onScrollListSource}>
                      {filteredArchitectsSource.length === 0 && !this.state.loading && (
                        <div className="merge-empty">
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={this.state.selectedTarget
                              ? "No architects found"
                              : "Please select Target Architect"}
                          />
                        </div>
                      )}
                      {filteredArchitectsSource.map(item =>
                        this.renderItem(item, selectedSources.some(selectedSource => selectedSource.pk === item.pk), this.onToggleSource)
                      )}
                      {this.state.loadingLoadMoreSource && (
                        <div style={{ textAlign: 'center', padding: '12px 0', color: '#8c8c8c', fontSize: '12px' }}>
                          <Spin size="small" style={{ marginRight: 8 }} /> Loading more...
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>

                {/* Target */}
                <Col span={12} className="merge-col merge-col-left">
                  <Row type="flex" className="h-100 flex-column flex-nowrap">
                    <Col className="flex-none merge-col-header">
                      {/* <div className=""> */}
                        <div className="merge-col-header-top">
                          <div className="merge-col-title">
                            {/* <Icon type="aim" style={{ marginRight: 6 }} /> */}
                            Target
                            {/* {this.state.architects.length > 0 && (
                              <span className="ml-1">
                                ({this.state.architects.length})
                              </span>
                            )} */}
                          </div>
                          {/* <Badge
                            count={selectedTarget ? 1 : 0}
                            style={{ backgroundColor: '#52c41a' }}
                            showZero
                          /> */}
                        </div>
                        <div className="merge-col-subtitle">Select one architect as the merge destination</div>
                        <Input.Search
                          enterButton
                          placeholder="Search target..."
                          prefix={<Icon type="search" style={{ color: '#bfbfbf' }} />}
                          // value={searchTarget}
                          defaultValue=""
                          // onChange={e => {
                          //   this.setState({ searchTarget: e.target.value })
                          // }}
                          onSearch={(val) => {
                            this._searchTarget = val
                            this.readArchitects()
                          }}
                          allowClear
                          size="small"
                          style={{ marginTop: 8 }}
                        />
                      {/* </div> */}
                    </Col>
                    <Col className="merge-col-list" onScroll={this.onScrollListTarget}>
                      {filteredArchitectsTarget.length === 0 && !this.state.loading && (
                        <div className="merge-empty">
                          {/* <Icon type="inbox" style={{ fontSize: 28, color: '#d9d9d9' }} />
                          <div>No architects found</div> */}
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="No architects found"
                          />
                        </div>
                      )}
                      {filteredArchitectsTarget.map(item =>
                        this.renderItem(item, get(selectedTarget, 'pk') === item.pk, this.onSelectTarget)
                      )}
                      {this.state.loadingLoadMoreTarget && (
                        <div style={{ textAlign: 'center', padding: '12px 0', color: '#8c8c8c', fontSize: '12px' }}>
                          <Spin size="small" style={{ marginRight: 8 }} /> Loading more...
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Center Arrow Indicator */}
              <div className="merge-center-arrow">
                <Tooltip title="Sources merge into Target">
                  <div
                    className="merge-arrow-circle"
                    onClick={() => {
                      // if (selectedTarget && selectedSources.length > 0 && !this.state.loading)
                      if (this.getAllowedMerge())
                        this.mergeArchitects()
                    }}
                  >
                    <Icon type="swap-right" style={{ fontSize: 20, color: '#fff' }} />
                  </div>
                </Tooltip>
              </div>
            </div>
          </Spin>
        )}
      </Modal>
    )
  }
}

DialogMergeArchitects.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

DialogMergeArchitects.defaultProps = {

}
